export function transformPixelsToRem(pixels: number): string {
    return `${pixels / 16}rem`;
}
